/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.components.data').service('DynamicPropertiesService', function(
    _,
    $q,
    $window,
    DynamicPropertiesResourceFactory
) {
	var self = this;

	self.properties = null;

	self.queryForProperties = function() {
		var deferred = $q.defer();
		if(self.properties) {
			deferred.resolve(self.properties);
		} else {
			DynamicPropertiesResourceFactory.query().$promise.then(function(props) {
			    self.properties = _.omitBy(props, function (propValue, propName) {
			        return !self.propNameIsValid(propName) || !_.isString(propValue);
                });
				deferred.resolve(self.properties);
			});
		}

		return deferred.promise;
	};

	self.getPropValue = function (propertyName, defaultString) {
		if(self.properties && self.properties[propertyName]) {
			return self.properties[propertyName];
		}
		if (defaultString !== undefined) {
		    return defaultString;
        }
		return '';
	};

    self.getPropValueAsBoolean = function (propertyName, defaultBool) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return strValue.toLowerCase() === 'true';
        }
        if (defaultBool !== undefined) {
            return defaultBool;
        }
        return false;
    };

    self.getPropValueAsInt = function (propertyName, defaultInt) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return parseInt(strValue);
        }
        if (defaultInt !== undefined) {
            return defaultInt;
        }
        return NaN;
    };

    self.getPropValueAsArray = function (propertyName, defaultArray) {
        var array = defaultArray;

        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            try {
                array = JSON.parse(strValue);
            } catch (error) {
                console.log(`error parsing dynamic property '${propertyName}' as JSON: ${error}`);
            } finally {
                if (!Array.isArray(array)) {
                    console.log(`dynamic property value for '${propertyName}' is not an array`);
                    array = defaultArray;
                }
            }
        }

        return array;
    };

    self.getPropValueAsList = function (propertyName, defaultList) {
        var strValue = self.getPropValue(propertyName);
        if (strValue) {
            return _.split(strValue, '|');
        }
        if (defaultList !== undefined) {
            return defaultList;
        }
        return [];
    };

    self.saveProperty = function (propertyName, value) {
        return DynamicPropertiesResourceFactory.updateProperties({
            [propertyName]: value
        }).$promise.then(function (results) {
            self.properties = null;
            return results;
        });
    };

    self.deleteProperty = function (propertyName) {
        return DynamicPropertiesResourceFactory.delete({
            propertyName: propertyName
        }).$promise.then(function (results) {
            self.properties = null;
            return results;
        });
    };


    //=================//
    // Property Checks //
    //=================//

    var hiddenDynamicProperties = _.get($window, '__wfcConfig.hiddenDynamicProperties', [
        'backupCayenneModel'
    ]);
    var confidentialProperties = _.get($window, '__wfcConfig.confidentialDynamicProperties', [
    ]);

    self.propNameIsValid = function(name) {
        return _.size(name) > 0 && !name.startsWith('$');
    };

    self.propIsEditable = function(name) {
        return self.propNameIsValid(name) && hiddenDynamicProperties.indexOf(name) === -1;
    };

    self.propContainsConfidentialInfo = function(name) {
        return name.match(/pass|secret|salt/i) || confidentialProperties.indexOf(name) !== -1;
    };
});
